import { addDays } from 'date-fns';

export function getHourFormatFromMinutes(minutes: number): string {
    const hours = minutes / 60;
    const rHours = Math.floor(hours);
    const totalMinutes = (hours - rHours) * 60;
    let rMinutes: number | string = Math.round(totalMinutes);
    rMinutes < 1 ? (rMinutes = '00') : '';
    return `${rHours}h${rMinutes}`;
}

export function calculateDifferenceInCalendarDays(startDate: Date, endDate: Date): number {
    const normalizedStartDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    const normalizedEndDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

    // Calculer la différence en millisecondes
    const differenceInMilliseconds = normalizedEndDate.getTime() - normalizedStartDate.getTime();

    // Convertir la différence en jours
    const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);

    // Arroundir à l'entier le plus bas
    return Math.ceil(differenceInDays);
}

export function timeToDate(date: Date, time: Date | string, refStartTime?: Date): Date {
    const splitTime =
        time instanceof Date
            ? [time.getHours(), time.getMinutes()]
            : time.split(':').map((timeValue) => parseInt(timeValue, 10));
    let newDate = new Date(date);
    // Setting hours, minutes, seconds, and milliseconds
    newDate.setHours(splitTime[0], splitTime[1], 0, 0);
    if (refStartTime) {
        if (refStartTime.getTime() < newDate.getTime()) {
            newDate.setDate(refStartTime.getDate());
            newDate.setMonth(refStartTime.getMonth());
            newDate.setFullYear(refStartTime.getFullYear());
        }
        while (newDate.getTime() <= refStartTime.getTime()) {
            newDate = addDays(newDate, 1);
        }
    }
    return newDate;
}
